var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-layout blank-layout"},[_c('div',{staticClass:"app-content blank-content"},[_c('div',{staticClass:"app-content-container"},[_c('router-view',{staticClass:"main-content-container"})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }